/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductList } from '@msdyn365-commerce/retail-proxy';
import { createProductListAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductListsDataActions.g';
/**
 * GetProductAttributesCartlines Input Action
 */
export class CreateAddProductListLinesInput implements Msdyn365.IActionInput {
    public productListEntity: ProductList;
    constructor(productListEntity: ProductList) {
        this.productListEntity = productListEntity;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `createAddProductListLines`;
    public getCacheObjectType = () => 'createAddProductListLines';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICreateAddProductListLines {
    result: ProductList;
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function createAddProductListLinesAction(
    input: CreateAddProductListLinesInput,
    ctx: Msdyn365.IActionContext
): Promise<ICreateAddProductListLines> {
    const createProductListLineResponse = await createProductListAsync({ callerContext: ctx }, input.productListEntity);
    return { result: createProductListLineResponse };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICreateAddProductListLines>>createAddProductListLinesAction,
    id: 'createAddProductListLines'
});
